import React from "react";
import { withTranslation } from "react-i18next";

const OddEvenComponent = (props) => {
  const betsPosition = {
    as: "as",
    kop: "kop",
    kepala: "kepala",
    ekor: "ekor",
  };

  const betChoose = ["odd", "even"];

  const combinedKey = {
    "as_odd": "as_ganjil",
    "as_even": "as_genap",
    "kop_odd": "kop_ganjil",
    "kop_even": "kop_genap",
    "kepala_odd": "kepala_ganjil",
    "kepala_even": "kepala_genap",
    "ekor_odd": "ekor_ganjil",
    "ekor_even": "ekor_genap"
  }

  return (
    <table className="tbl_3 fifty_tbl_1">
      <thead>
        <tr>
          <th className="table-position">{props.t("position")}</th>
          <th>
            <table className="tbl_hd_1">
              <thead>
                <tr>
                  <th className="guess-thtable">{props.t("guess")}</th>
                  <th className="offtext">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span className="guess-span" style={{ padding: "0 10px", background: "none", border: "none" }}>{props.t("kei")}</span>
                      <input
                        id="inputs"
                        type="text"
                        autoComplete="off"
                        placeholder="Auto Bet"
                        value={props.defaultValue}
                        onChange={props.handleDeafultInputChange}
                        onBlur={props.handleDeafultInputBlur}
                        className="input-odd"
                      />
                    </div>
                  </th>
                </tr>
              </thead>
            </table>
          </th>

          {/* <th colSpan={3} style={{ padding: "0" }}>
            <table className="data-table" style={{ border: 0 }}>
              <thead>
                <tr>
                 
                 
                </tr>
              </thead>
            </table>
          </th> */}
        </tr>
      </thead>
      <tbody>
        {Object.values(betsPosition).map((val, index) => (
          <tr>
            <td
              className={
                index % 2 == 0
                  ? "first-input-row even-row"
                  : "first-input-row odd-row"
              }
              style={{ padding: "0" }}
            >
              {props.t(val)}
              <input value={val} type="hidden" />
            </td>
            <td style={{ padding: "0" }} className={
              index % 2 == 0
                ? "first-input-row even-row"
                : "first-input-row odd-row"
            }>
              <table className="data-table tbl_2" style={{ border: 0 }}>
                <tbody>
                  {betChoose.map((item, ind) => (
                    <tr className="odd-even-row">
                      <td className="second-row">
                        {props.t(item)}
                        <input
                          name={`${val}_${item}`}
                          value={item == "odd" ? "ganjil" : "genap"}
                          type="hidden"
                        />
                      </td>
                      <td className="third-even-row">
                        <div style={{ display: "flex" }}>
                          <input
                            className="kei-row"
                            type="text"
                            // value={betDiscount.kei_as_besar + '%'}
                            value={
                              props.betDiscount.kei_as_besar
                                ? props.betDiscount.kei_as_besar + "%"
                                : ""
                            }
                            readOnly
                            style={{ padding: "0 10px", background: "none", border: "none" }}
                          />
                          <input
                            type="text"
                            placeholder="Bet"
                            name={`${val}_${item}`}
                            value={props.beli[combinedKey[`${val}_${item}`]] || ''}
                            autoComplete="off"
                            onChange={(e) => props.handleInputChange(e, index * 2, ind)}
                            onBlur={(e) => props.handleInputBlur(e, index * 2, ind)}
                            onFocus={(e) => props.handleInputFocus(e, index * 2, ind)}
                            inputMode="decimal"
                            pattern="[0-9]*[.,]?[0-9]**"
                            id="inputs"
                            style={{ padding: "8px 0px" }}
                            className="input-odd"
                          />
                        </div>
                      </td>
                      {/* <td className="main-input-row">
                        
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default withTranslation()(OddEvenComponent);
